import useStore from "../../../store"
import { useTranslation } from "react-i18next"
import { NeutralButton } from "../../common/Buttons"
import { FaExternalLinkAlt } from "react-icons/fa"
import ActionConfirmDrawer from "../../common/ActionConfirmDrawer"
import { useState } from "react"
import { Textarea, Field } from '@chakra-ui/react'
import { SelectContent, SelectItem, SelectRoot, SelectTrigger, SelectValueText } from "../../ui/select"
import { colors } from "../../../utilities/colors"
import { createListCollection } from "@chakra-ui/react"
import { isArbitrated } from "../../../utilities/unitUtilities"
import useUserType from "../../../hooks/useUserType"

export default function UnitTitleRequest({ unit }) {
  const { t } = useTranslation()
  const { createTitleRequestTicket, setErrMessage } = useStore()
  const [isOpen, setIsOpen] = useState(false)
  const [notes, setNotes] = useState('')
  const [destination, setDestination] = useState('')
  const [destinationError, setDestinationError] = useState(false)
  const [isConfirming, setIsConfirming] = useState(false)
  const { isEmployee } = useUserType()

  const destinationOptions = createListCollection({
    items: [
      !isArbitrated(unit) && { label: t('Title to Dealer'), value: 'TTD' },
      { label: t('Title to Auction'), value: 'TTA' },
      isEmployee && { label: t('Title to Employee'), value: 'TTE' },
    ].filter(Boolean),
  })

  const handleCreateTitleRequestTicket = async () => {
    if (isConfirming) return

    if (!destination) {
      setDestinationError(true)
      setErrMessage(t('Destination is a required field'))
      return
    }

    setIsConfirming(true)
    try {
      await createTitleRequestTicket(unit.id, {
        notes: notes,
        title_destination: destination
      })
      setIsOpen(false)
      setNotes('')
      setDestination('')
    } finally {
      setIsConfirming(false)
    }
  }

  if (unit.attributes['title-tracking-link']) {
    return (
      <NeutralButton
        text={<span className="flex items-center gap-2">{t('Track Title')} <FaExternalLinkAlt /></span>}
        onClick={() => window.open(unit.attributes['title-tracking-link'], '_blank')}
      />
    )
  }

  if (unit.attributes['dealer-title-request']) {
    return (
      <NeutralButton
        text={t('Title Request Sent')}
        disabled={true}
      />
    )
  }

  return(
    <>
      <NeutralButton
        text={t('Request Title')}
        onClick={() => setIsOpen(true)}
      />
      <ActionConfirmDrawer
        title={t('Request Title')}
        onConfirm={handleCreateTitleRequestTicket}
        onCancel={() => setIsOpen(false)}
        isConfirming={isConfirming}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        body={
          <>
            <Field.Root id="notes" mb={2}>
              <Field.Label fontSize={'sm'} color={colors.grey300} htmlFor="notes">{t('Add Notes/ Location')}</Field.Label>
              <Textarea
                id="notes"
                placeholder={t('Add Notes/ Location')}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                bgColor={colors.grey900}
                borderRadius='md'
                _focus={{ borderColor: colors.grey100, ringColor: colors.grey100 }}
              />
            </Field.Root>
            <Field.Root id="destination" mb={2}>
              <Field.Label fontSize={'sm'} color={colors.grey300} htmlFor="destination">{t('Destination')}</Field.Label>
              <SelectRoot
                collection={destinationOptions}
                onValueChange={(value) => {
                  setDestination(value.value[0])
                  setDestinationError(false)
                }}
              >
                <SelectTrigger borderWidth={2} borderColor={destinationError ? colors.fpxRed : colors.grey} _focus={{ borderColor: colors.grey300 }} rounded="md" p={2}>
                  <SelectValueText placeholder="Select Destination" />
                </SelectTrigger>
                <SelectContent portalled={false} width="full" >
                  {destinationOptions.items.map((item) => (
                    <SelectItem item={item} key={item.value} _hover={{ bgColor: colors.grey, cursor: 'pointer' }} >
                      {item.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </SelectRoot>
            </Field.Root>
          </>
        }
      />
    </>
  )
}